import { Company, Order, OrderItem } from "types/models";
import { taxMultiplierForCompany } from "utils/models/company";

export const CREATING = "creating";
export const COMPLETED = "completed";
export const GENERATED = "generated";
export const ERRORED = "errored";

export type Status =
  | typeof CREATING
  | typeof COMPLETED
  | typeof GENERATED
  | typeof ERRORED;

type StatusOption = {
  id: Status;
  label: string;
};

export const STATUS_OPTIONS: StatusOption[] = [
  { id: CREATING, label: "En proceso de creación" },
  { id: COMPLETED, label: "Completada" },
  { id: GENERATED, label: "Generada" },
  { id: ERRORED, label: "Con error" },
];

export const isCreating = (order?: Order) => order?.status === CREATING;
export const isCompleted = (order?: Order) => order?.status === COMPLETED;
export const isGenerated = (order?: Order) => order?.status === GENERATED;
export const isErrored = (order?: Order) => order?.status === ERRORED;

export const humanizeOrder = (order: Order) => {
  if (isCreating(order)) return "En proceso de creación";
  if (isCompleted(order)) return "Completada";
  if (isGenerated(order)) return "Generada";
  if (isErrored(order)) return "Error";
  return "";
};

const DELIVERY_PRODUCT_EXTERNAL_ID = "varmoto";

// Matches current and potential future ERP delivery product names:
// "Gasto de envio moto remis", "Gasto de envio", etc.
export const isDeliveryProduct = (item: OrderItem): boolean => {
  if (item.product_external_id.toLowerCase() === DELIVERY_PRODUCT_EXTERNAL_ID)
    return true;
  const name = (item.product_name ?? "").toLowerCase();
  return name.includes("gasto") && name.includes("envio");
};

// Returns the total cost (with tax) of a delivery product item.
export const deliveryProductCost = ({
  item,
  company,
}: {
  item: OrderItem;
  company?: Company;
}): number =>
  item.product_itris_final_unit_price *
  (1 - item.product_itris_final_discount / 100) *
  item.amount *
  taxMultiplierForCompany({ company });
